import { BrowserRouter, Routes, Route, Link, useLocation } from "react-router-dom";
import Mobile from "./pages/Mobile";
import Admin from "./pages/Admin";
import Login from "./pages/Login";
import { useEffect } from "react";

import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

function NavButton(){
  const location = useLocation();

  if(location.pathname === "/mobile"){
    return <Link to="/" style={btn}>Kartta</Link>;
  }
  return <Link to="/mobile" style={btn}>Mobile view</Link>;
}

const btn = {
  position:"fixed",
  top:15,
  left:15,
  zIndex:999999,
  background:"#001f26",
  color:"#00e5ff",
  padding:"8px 14px",
  borderRadius:10,
  textDecoration:"none"
};

export default function App(){

  const token = localStorage.getItem("accessToken");

  // 🔥 FIREBASE PUSH KÄYNNISTYY VASTA LOGININ JÄLKEEN
  useEffect(() => {

    if(!token) return;

    async function initFirebasePush(){

      if (!("serviceWorker" in navigator)) return;
      await navigator.serviceWorker.ready;

      const firebaseConfig = {
        apiKey: "AIzaSyBQEKaSpuL7lRIjmDD8y_zr_3jUHq2ENGo",
        authDomain: "zoomon-afe35.firebaseapp.com",
        projectId: "zoomon-afe35",
        storageBucket: "zoomon-afe35.appspot.com",
        messagingSenderId: "663412672680",
        appId: "1:663412672680:web:2720f73890f325e287da9d"
      };

      const app = initializeApp(firebaseConfig);
      const messaging = getMessaging(app);

      const perm = await Notification.requestPermission();
      if (perm !== "granted") return;

      const fcmToken = await getToken(messaging,{
        vapidKey:"BJnNsncj9_UBLisoamfkvC8NkoRN6hnH9k3YAf0ATYtFnAxSkHET11kWUvi-IfqCwFX2aANoXyajMlz7_ica36o"
      });

      // lähetä serverille
      await fetch("/api/push/register",{
        method:"POST",
        headers:{ "Content-Type":"application/json" },
        body:JSON.stringify({ token:fcmToken })
      });

      onMessage(messaging,(payload)=>{
        new Notification(payload.data?.title || "Tradeon",{
          body: payload.data?.body || ""
        });
      });
    }

    initFirebasePush();

  }, [token]);

  // 🔐 LOGIN GATE
  if(!token){
    return <Login/>;
  }

  return (
    <BrowserRouter>
      <NavButton/>
      <Routes>
        <Route path="/" element={<Admin/>}/>
        <Route path="/mobile" element={<Mobile/>}/>
      </Routes>
    </BrowserRouter>
  );
}